import apiClient from "../apiClient";

export const completeInformationProvider = async (providerData) => {
  try {
    const newData = { ...providerData };
    const formData = new FormData();
    const ImgUri = newData.imageFile;

    // 1. Agregar imagen (formato correcto)
    if (ImgUri) {
      formData.append("img", ImgUri);
    }

    delete newData.imageFile;

    for (const key in newData) {
      const value = newData[key];
      if (value !== null && value !== undefined && value !== "") {
        if (key === "phoneNumber") {
          formData.append(key, `+52${value}`);
        } else {
          formData.append(key, value);
        }
      }
    }
    // console.log("Completando perfil", formData);
    const response = await apiClient.put(
      `proffessionals/completeInformationSP`,
      formData
    );
    return response;
  } catch (error) {
    // console.log("❌ respuesta API", error.request || error.message);
    throw error;
  }
};

export const updateProfileProvider = async ({ userData, _id }) => {
  try {
    // console.log("UserData perfil", userData);

    const newData = { ...userData };
    const formData = new FormData();
    const ImgUri = newData.imageFile;

    // 1. Agregar imagen (formato correcto)
    if (ImgUri) {
      formData.append("img", ImgUri);
    }

    // 2. Address como JSON string
    // const address = {
    //   street: newData.street || "",
    //   city: newData.city || "",
    //   state: newData.state || "",
    //   postalCode: newData.postalCode || "",
    // };
    // console.log(address);

    // formData.append("address", address);

    // 3. Agregar otros campos
    const excludeFields = [
      "street",
      "city",
      "state",
      "postalCode",
      "urlImg",
      "phoneNumber",
      "imageFile",
    ];
    for (const key in newData) {
      if (
        !excludeFields.includes(key) &&
        newData[key] !== undefined &&
        newData[key] !== null
      ) {
        formData.append(key, newData[key]);
      }
    }
    // console.log("FromData", formData);

    // 4. Configuración de Axios
    const response = await apiClient.put(
      `proffessionals/updateServiceProvider/${_id}`,
      formData
    );

    // console.log("✅ Perfil actualizado:", response.data);
    return response.data;
  } catch (error) {
    // console.log("❌ Error completo:", error.request);
    throw error;
  }
};

export const getAllUsers = async () => {
  try {
    const response = await apiClient.get("users/getAllUsers");
    // console.log("Respuesta get all users", response?.data?.data);
    return response?.data?.data ?? [];
  } catch (error) {
    throw error;
  }
};

export const getAllPatientsOfProvider = async (_id) => {
  try {
    const response = await apiClient.get(
      `proffessionals/getListPatients/${_id}`
    );
    // console.log("list patients", response?.data?.data);

    return response.data?.data ?? [];
  } catch (error) {
    throw error;
  }
};

export const validateSMSProvider = async (userData) => {
  try {
    const response = await apiClient.put("verify/verify-sms", userData);
    return {
      status: true,
      data: response.data,
    };
  } catch (error) {
    throw error;
  }
};

export const AddUserOfListPatient = async (userData, idProvider) => {
  try {
    // console.log("Data recibida", userData, idProvider);

    const response = await apiClient.post(
      `proffessionals/addPatientList/${idProvider}`,
      userData
    );
    // console.log("Response in post add user in list patients", response?.data);
    return response?.data;
  } catch (error) {
    throw error;
  }
};

export const deleteUserOfListPatients = async (userId, providerId) => {
  try {
    // console.log("Id provider", providerId);
    // console.log(
    //   "Url peticion",
    //   `proffessionals/deletePatientList/providers/${providerId}`
    // );
    // console.log("data recibida delete", userData);
    const response = await apiClient.delete(
      `proffessionals/deletePatientList/providers/${providerId}`,
      { data: { userId } }
    );
    // console.log("REsponse delete user", response.data);

    return response?.data;
  } catch (error) {
    // console.log("Error delete user", error);

    throw error;
  }
};
